var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BSCButtonSelect"},_vm._l((_vm.buttons),function(button){return _c('button',{key:button.item,staticClass:"BSCButtonSelect-buttons",class:[
      `is-${_vm.type}`,
      { 'BSCButtonSelect-buttons-selected': button.value === _vm.newValue.value }
    ],on:{"click":function($event){return _vm.selected(button)}}},[_c('span',{staticClass:"BSCButtonSelect-buttons-label"},[_vm._v(_vm._s(button.label))]),(button.img !== undefined && button.img !== null)?_c('div',{staticClass:"BSCButtonSelect-buttons-image"},[_c('img',{attrs:{"src":button.img}})]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }